import React from "react";
import * as Icons from "lucide-react";

/**
 * Render a lucide icon by its PascalCase name string.
 */
export default function LucideIcon({ name, className = "h-5 w-5", strokeWidth = 1.8 }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
